import React, { useContext } from 'react';
import { NavLink } from "react-router-dom";
import styles from './Navigation.module.css';
import { ThemeContext } from '../contexts/ThemeContext';

const Navigation = () => {
  const { dark } = useContext(ThemeContext);

  return (
    <>
      <nav>
        <ul className={styles.navList}>
          <li><NavLink
            to="/"
            exact
            className={dark ? styles.navLiDark : styles.navLiLight}
            activeClassName={dark ? styles.navLiActiveDark : styles.navLiActiveLight}
          >Početna</NavLink></li>
          <li><NavLink
            to="/oglasi"
            className={dark ? styles.navLiDark : styles.navLiLight}
            activeClassName={dark ? styles.navLiActiveDark : styles.navLiActiveLight}
          >Oglasi</NavLink></li>
          {/*<li><NavLink
            to="/raspored"
            className={dark ? styles.navLiDark : styles.navLiLight}
            activeClassName={dark ? styles.navLiActiveDark : styles.navLiActiveLight}
          >Raspored nastave</NavLink></li>*/}
          <li><NavLink
            to="/zavrsni-radovi"
            className={dark ? styles.navLiDark : styles.navLiLight}
            activeClassName={dark ? styles.navLiActiveDark : styles.navLiActiveLight}
          >Završni radovi</NavLink></li>
        </ul>
      </nav>
    </>
  );
}

export default Navigation;